import React from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";

function PrivacyPolicy() {
  return (
        <>
    <Head />
    
    
  {/* Start Breadcrumbs */}
  <section className="ak-about-hero-1">
    <img
      src="assets/img/bg/policy.jpg"
      className="about-hero-bg ak-bg object-cover"
      alt="..."
      data-swiper-parallax={1152}
    />
    <div className="container">
      <div className="about-hero-content">
        <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
          <p
            className="ak-section-subtitle animation-title"
            style={{ color: "white !important" }}
          >
            Policy
          </p>
          <h2
            className="ak-section-title animation-title"
            style={{ color: "white" }}
          >
            Privacy Policy
          </h2>
        </div>
        <a href="/" className="back-btn" style={{ color: "white" }}>
          Home / Policy / Privacy Policy
        </a>
      </div>
    </div>
  </section>
  {/* End Breadcrumbs */}
  {/* Start About  */}
  <div className="ak-height-125 ak-height-lg-80" />
  <section>
    <div className="about-us-content-bg">
      <div className="container">
        {/* <div className="about-us-content"> */}
         
<div className="info-content">
  <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
    <p className="ak-section-subtitle animation-title">
      POLICY
    </p>
    <h2 className="ak-section-title animation-title">
      PRIVACY POLICY
    </h2>

    <p className="ak-section-desp">
      At IFMEDU ACADEMY PRIVATE LIMITED, we are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy outlines how we collect, use, store, and protect your data when you interact with our website <a href="https://ifmedu.in">https://ifmedu.in</a> or enroll in our programs.
    </p>

    <p className="ak-section-desp">
      <strong>1. Information We Collect</strong><br />
      We may collect personal information such as your name, email address, phone number, educational background, and payment details when you:
      <ul>
        <li>Register or enroll in a course</li>
        <li>Submit an inquiry or contact form</li>
        <li>Subscribe to newsletters or updates</li>
        <li>Make a payment or request a quote</li>
      </ul>
    </p>

    <p className="ak-section-desp">
      <strong>2. How We Use Your Information</strong><br />
      The information we collect is used to:
      <ul>
        <li>Process course registrations and payments</li>
        <li>Provide academic and administrative support</li>
        <li>Send important updates, schedules, and promotional content</li>
        <li>Respond to inquiries and provide customer service</li>
        <li>Improve our website and services</li>
      </ul>
    </p>

    <p className="ak-section-desp">
      <strong>3. Data Sharing and Disclosure</strong><br />
      We do not sell or rent your personal information. We may share your data with:
      <ul>
        <li>Authorized staff and instructors for academic purposes</li>
        <li>Payment gateways and service providers for transaction processing</li>
        <li>Government or legal authorities if required by law</li>
      </ul>
    </p>

    <p className="ak-section-desp">
      <strong>4. Data Security</strong><br />
      We implement appropriate technical and organizational measures to protect your personal data from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure.
    </p>

    <p className="ak-section-desp">
      <strong>5. Cookies and Tracking</strong><br />
      Our website may use cookies to enhance user experience, analyze traffic, and personalize content. You can choose to disable cookies through your browser settings.
    </p>

    <p className="ak-section-desp">
      <strong>6. Your Rights</strong><br />
      You have the right to:
      <ul>
        <li>Access the personal data we hold about you</li>
        <li>Request correction or deletion of your data</li>
        <li>Withdraw consent for marketing communications</li>
      </ul>
      To exercise these rights, please contact us at <a href="mailto:enquiry@ifmedu.in">enquiry@ifmedu.in</a>.
    </p>

    <p className="ak-section-desp">
      <strong>7. Changes to This Policy</strong><br />
      We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
    </p>

    <p className="ak-section-desp">
      <strong>8. Contact Us</strong><br />
      If you have any questions or concerns about this Privacy Policy, please contact us:<br />
      📧 enquiry@ifmedu.in<br />
      📞 +91 90486 48777<br />
      📍 IFMEDU ACADEMY PRIVATE LIMITED, VSK TOWER, Opp. TVS Junction, Ernakulam, Kerala – 682019
    </p>
  </div>
</div>

        {/* </div> */}
        <div className="ak-height-125 ak-height-lg-80" />
      </div>
      <img className="aboutus" src="assets/img/bg/aboutus.png" alt="..." />
    </div>
  </section>
  {/* End About  */}




    <Foot />
    </>
  )
}

export default PrivacyPolicy